// extracted by mini-css-extract-plugin
export default {"wrapper":"Loader_wrapper__sadND","wrapper_bg":"Loader_wrapper_bg__KP0j2","loader":"Loader_loader__DwtSp","l17":"Loader_l17__9NBC-"};